import { Icon, Menu } from 'antd';
import React from 'react';
import { useReviews } from '../Reviews/containers/ReviewsDataStore';
import TiledTitleList from '../Titles/TiledTitleList';
import { useDownloads } from './containers/DownloadsDataStore';
import DownloadType from './DownloadType';
import {
	getDownloadedReviewedSku,
	getDownloadedNotReviewedSku,
} from './DownloadFilters';

export default function DownloadsMenu() {
	const downloadsDataStore = useDownloads();
	const { downloads, selectedMenuOption } = downloadsDataStore.state;

	const handleClick = e => {
		downloadsDataStore.setSelectedMenuOption(e.key);
	};

	const downloadSkus = downloads.map(item => item.sku);

	const reviewsDataStore = useReviews();
	const { reviews } = reviewsDataStore.state;
	const reviewedSkus = reviews && reviews.map(item => item.sku);

	const renderDownloads = isLoading => {
		const skus = getSkusToRender();
		return (
			<TiledTitleList
				skus={skus}
				isLoading={isLoading}
				titles={downloads}
			/>
		);
	};

	const renderMenuItem = (items, downloadType) => {
		return (
			((items && items.length > 0) || downloadType.doShowIfZero) && (
				<Menu.Item key={downloadType.key}>
					<Icon type={downloadType.key} />
					<b>{items.length}</b> {downloadType.text}
				</Menu.Item>
			)
		);
	};

	const getSkusToRender = () => {
		switch (selectedMenuOption) {
			case DownloadType.DownloadedNotReviewed.key:
				return getDownloadedNotReviewedSku(downloadSkus, reviewedSkus);
			case DownloadType.DownloadedReviewed.key:
				return getDownloadedReviewedSku(downloadSkus, reviewedSkus);
			case DownloadType.All.key:
				return downloadSkus;
		}
	};

	return (
		<>
			<div>
				<Menu
					onClick={handleClick}
					selectedKeys={[selectedMenuOption]}
					mode="horizontal">
					{renderMenuItem(downloadSkus.length, DownloadType.All)}
					{renderMenuItem(
						getDownloadedNotReviewedSku(downloadSkus, reviewedSkus),
						DownloadType.DownloadedNotReviewed,
					)}
					{renderMenuItem(
						getDownloadedReviewedSku(downloadSkus, reviewedSkus),
						DownloadType.DownloadedReviewed,
					)}
				</Menu>
			</div>
			{renderDownloads()}
		</>
	);
}
